import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography/Typography';

const SignatureHeader = () => {
  return (
    <div>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <i
          className="fa-light fa-signature"
          style={{ fontSize: '20px', color: 'white' }}
        />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Digital Signature
        </Typography>
      </Box>
      <div className="mb-6">
        <p className="text-base leading-relaxed">
          Please sign in the designated area below. Your signature will be
          securely stored and used for document verification after you accept
          your signature.
        </p>
      </div>
    </div>
  );
};

export default SignatureHeader;
